import { createPortal } from 'react-dom'
import { useOnboarding } from '@/contexts/OnboardingContext'
import { getTourSteps } from '@/data/tours'
import { useAnchoredPosition } from '@/hooks/useAnchoredPosition'
import { SpotlightOverlay } from './SpotlightOverlay'
import { TourTooltip } from './TourTooltip'

export function TourController() {
	const { state, nextStep, prevStep, skipTour, completeTour } = useOnboarding()
	const { activeTour, currentStepIndex } = state

	const steps = activeTour ? getTourSteps(activeTour) : []
	const currentStep = steps[currentStepIndex]
	const totalSteps = steps.length

	const { coords, actualPosition } = useAnchoredPosition({
		anchor: currentStep?.target ?? null,
		position: currentStep?.position ?? 'right',
		fallback: currentStep?.position === 'right' ? 'left' : 'right',
	})

	if (!activeTour || !currentStep) return null

	const handleNext = () => {
		if (currentStepIndex >= totalSteps - 1) {
			completeTour()
		} else {
			nextStep()
		}
	}

	return createPortal(
		<>
			<SpotlightOverlay target={currentStep.target} onClickOutside={skipTour} />
			{coords && (
				<div
					className="tour-tooltip-container"
					style={{ position: 'fixed', top: coords.top, left: coords.left, zIndex: 10000 }}
					data-position={actualPosition}
				>
					<TourTooltip
						title={currentStep.title}
						content={currentStep.content}
						stepNumber={currentStepIndex + 1}
						totalSteps={totalSteps}
						onNext={handleNext}
						onBack={prevStep}
						onSkip={skipTour}
					/>
				</div>
			)}
		</>,
		document.body,
	)
}
